var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74658 7.00016L13.6349 2.11184C13.8669 1.88025 13.9974 1.56599 13.9977 1.23818C13.998 0.910372 13.868 0.595877 13.6365 0.363878C13.4049 0.131879 13.0906 0.00138126 12.7628 0.00109176C12.435 0.000802264 12.1205 0.130745 11.8885 0.362335L7.00016 5.25066L2.11184 0.362335C1.87984 0.130336 1.56518 0 1.23709 0C0.908992 0 0.594334 0.130336 0.362335 0.362335C0.130336 0.594334 0 0.908992 0 1.23709C0 1.56518 0.130336 1.87984 0.362335 2.11184L5.25066 7.00016L0.362335 11.8885C0.130336 12.1205 0 12.4351 0 12.7632C0 13.0913 0.130336 13.406 0.362335 13.638C0.594334 13.87 0.908992 14.0003 1.23709 14.0003C1.56518 14.0003 1.87984 13.87 2.11184 13.638L7.00016 8.74967L11.8885 13.638C12.1205 13.87 12.4351 14.0003 12.7632 14.0003C13.0913 14.0003 13.406 13.87 13.638 13.638C13.87 13.406 14.0003 13.0913 14.0003 12.7632C14.0003 12.4351 13.87 12.1205 13.638 11.8885L8.74658 7.00016Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.078d1f71aa91996516c44cb11025ca54.svg";
export { ForwardRef as ReactComponent };